import { render } from "./MenuLinks.vue?vue&type=template&id=739f9243"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Employ/Navigation/MenuLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "739f9243"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('739f9243', __exports__)) {
    api.reload('739f9243', __exports__)
  }
  
  module.hot.accept("./MenuLinks.vue?vue&type=template&id=739f9243", () => {
    api.rerender('739f9243', render)
  })

}


export default __exports__